"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../assets/styles/config");
exports.StyledButton = styled_components_1.default.button `
  font: ${config_1.fontSizes.medium} ${config_1.fontFamilies.primary};
  background: ${({ disabled }) => disabled ? config_1.colors.grayText : config_1.colors.blurple};
  border-color: ${({ disabled }) => disabled ? config_1.colors.grayText : config_1.colors.blurple};
  color: ${({ disabled }) => (disabled ? config_1.colors.black : config_1.colors.white)};
  height: 43px;
  margin: ${({ margin }) => (margin ? margin : '0')};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '230px')};
  min-width: ${({ minWidth }) => (minWidth ? minWidth : '130px')};
  padding: 0;
  width: 20%;

  &:hover,
  &:focus {
    background: ${config_1.colors.indigo};
    box-shadow: none;
  }
`;
